import { useState, useEffect } from 'react'

export default function UpdatePrompt() {
  const [show, setShow] = useState(false)
  const [reg, setReg] = useState<ServiceWorkerRegistration | null>(null)

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    navigator.serviceWorker.ready.then(registration => {
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (!newWorker) return
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            setReg(registration)
            setShow(true)
          }
        })
      })
    })
  }, [])

  function handleUpdate() {
    if (reg?.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    window.location.reload()
  }

  if (!show) return null

  return (
    <div
      className="fixed bottom-24 md:bottom-6 left-1/2 -translate-x-1/2 z-[80] flex items-center gap-3 px-4 py-3 rounded-ab border"
      style={{
        background: 'rgba(8,14,26,0.97)',
        borderColor: 'rgba(0,240,255,0.3)',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 0 20px rgba(0,240,255,0.1)',
      }}
    >
      <span className="text-lg flex-shrink-0">⚡</span>
      <div className="flex-1">
        <p className="font-display font-bold text-sm text-ab-text">Update available</p>
        <p className="text-body text-xs opacity-60">New version ready to install</p>
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => setShow(false)}
          className="font-display font-bold text-xs text-ab-text-dim hover:text-ab-text transition-colors bg-transparent border-none cursor-pointer"
        >
          Later
        </button>
        <button onClick={handleUpdate} className="btn-primary text-xs px-3 py-1.5">
          Update
        </button>
      </div>
    </div>
  )
}
